import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import VideoSection from './components/VideoSection';
import { videos, categories } from '@/mocks/videos';

export default function Home() {
  const hotVideos = videos.filter(v => v.rating >= 8.0).slice(0, 6);
  const guochanjuVideos = videos.filter(v => v.category === 'guochanju').slice(0, 6);
  const hanjuVideos = videos.filter(v => v.category === 'hanju').slice(0, 6);
  const dongmanVideos = videos.filter(v => v.category === 'dongman').slice(0, 6);
  const latestVideos = [...videos].sort((a, b) => b.year - a.year).slice(0, 6);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '555电影',
    url: 'https://www.555movie.com',
    description: '555电影为您汇集电视剧全集免费在线观看，最新热播剧集、国产剧、韩剧等高清资源，无需缓冲，追剧首选平台。',
    potentialAction: {
      '@type': 'SearchAction',
      'target': 'https://www.555movie.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '555电影',
    url: 'https://www.555movie.com',
    description: '555电影为您汇集电视剧全集免费在线观看，最新热播剧集、国产剧、韩剧等高清资源，无需缓冲，追剧首选平台。',
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '555电影 - 首页',
    description: '555电影首页，汇集最新热播剧集、国产剧、韩剧等高清资源，追剧首选平台。',
    url: 'https://www.555movie.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '555电影',
      url: 'https://www.555movie.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryTabs />
          <VideoSection
            title="热播推荐"
            subtitle="评分最高的精选好剧"
            videos={hotVideos}
          />
          <VideoSection
            title="国产剧"
            subtitle="最新国产热播剧集"
            videos={guochanjuVideos}
            viewAllLink="/category/guochanju"
            viewAllText="更多国产剧"
          />
          <VideoSection
            title="韩剧"
            subtitle="热门韩剧精选"
            videos={hanjuVideos}
            viewAllLink="/category/hanju"
            viewAllText="更多韩剧"
          />
          <VideoSection
            title="动漫"
            subtitle="热门国漫精选"
            videos={dongmanVideos}
            viewAllLink="/category/dongman"
            viewAllText="更多动漫"
          />
          <VideoSection
            title="最新更新"
            subtitle="最近更新的精彩内容"
            videos={latestVideos}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}